import { Button } from "@circleco/compass/components/Button";
import type { ComponentPropsWithoutRef, MouseEvent, ReactNode } from "react";

type CompassButtonProps = ComponentPropsWithoutRef<typeof Button>;

type ActionButtonProps = Readonly<{
  children: ReactNode;
  compressedCTA?: boolean;
  disabled?: boolean;
  onClick?: (
    event: MouseEvent<HTMLButtonElement>,
  ) => void | Promise<void> | Promise<unknown>;
  startIcon?: CompassButtonProps["startIcon"];
  variant?: CompassButtonProps["variant"];
  "data-testid"?: string;
}>;

export const ActionButton = ({
  children,
  compressedCTA = false,
  disabled,
  onClick,
  startIcon,
  variant = "outline",
  "data-testid": dataTestId,
}: ActionButtonProps) => (
  <Button
    variant={variant}
    size={compressedCTA ? "md" : "lg"}
    disabled={disabled}
    onClick={event => void onClick?.(event)}
    startIcon={startIcon}
    data-testid={dataTestId}
  >
    {children}
  </Button>
);
